import React, { createContext, useContext, useState } from "react";
import { dict } from "./translations";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");

  const setLanguage = (newLang) => {
    setLang(newLang);
    localStorage.setItem("lang", newLang);
  };

  const toggle = () => {
    const nl = lang === "en" ? "hi" : "en";
    setLang(nl);
    localStorage.setItem("lang", nl);
  };

  const t = (k) => (dict[lang] && dict[lang][k]) || dict["en"]?.[k] || k;

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
